import { WhmBox, WhmContainer } from "@securitize/reactjs-whm";
import Profile from "../../components/Profile/Profile";
import UserContext from "../../contexts/UserContext";
import { MOCK_USER_INFO } from "../mockUserInfo";

export default function ProfileView() {
  return (
    <WhmContainer>
      <WhmBox>
        <UserContext userInfo={MOCK_USER_INFO}>
          <Profile />
        </UserContext>
      </WhmBox>
    </WhmContainer>
  );
}
